<section class="section" #screen id="mainGraph">
    <div class="shell shell--size-3">
        <br />
        <div class="row chart" id="chartSize">
            <div class="col">
                <!-- <div class="chart__head hidden-xs"> -->
                <div class="chart__head">
                    <div class="chart__head-content" style="line-height: 0%;">
                        <!-- <h6>eToro Analysis</h6> -->

                        <h6>Cosmic Algorithm Ltd.</h6>

                        <span style="font-size: x-small" *ngIf="mobile">LIVE: {{DynamUpd}}</span><br />
                        <span style="font-size: small" *ngIf="!mobile">LIVE: {{DynamUpd}}</span><br />
                        <!-- <span>Last Updated: {{updateRecent}}</span> -->
                    </div><!-- /.chart__head-content -->

                </div><!-- /.chart__head -->
            </div>
            <div *ngIf="!mobile" class="col-auto legendGrad legendShadow" id="legendLive">
                <div id="legendItemsLive">
                    <div class="row" style="display: none">
                        <div class="col">AGR - 2021 (Traded Gain)</div>
                        <div class="col"><span id="tGain"><span *ngIf="gPos">+</span>{{tGain}}%</span> </div>
                    </div>
                    <div class="row" style="margin-bottom: -1vh">
                        <div class="col-auto">AGR +/- (Since Oct 2022)</div>
                        <div class="col-auto" style="text-align: right;"><span id="tLaunch"><span *ngIf="lPos">+</span>{{last}}%</span></div>
                    </div>
                    <div class="row">
                        <div class="col-auto">Gain +/- (Since Oct 2022)</div>
                        <div class="col-auto" style="text-align: right;"><span id="tNSDQ"><span *ngIf="nPos">+</span>{{tLaunch}}%</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="mobile" class="row legendGrad legendShadow" id="legendLive" style="width: 93%; margin: auto;">
            <div id="legendItemsLive">
                <div class="row" style="display: none">
                    <div class="col">AGR - 2021 (Traded Oct 2022)</div>
                    <div class="col-auto legendPadMob"><span id="tGain"><span *ngIf="gPos">+</span>{{tGain}}%</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col">AGR +/- (Since Oct 2022)</div>
                    <div class="col-auto legendPadMob"><span id="tLaunch"><span *ngIf="lPos">+</span>{{last}}%</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col">Gain +/- (Since Oct 2022)</div>
                    <div class="col-auto legendPadMob"><span id="tNSDQ"><span *ngIf=nPos>+</span>{{tLaunch}}%</span>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div class="row chart">
            <div class="chart__body" class="wow fadeInRight" data-wow-delay=".5s" id="chart">
                <div *ngIf="!isUser" id="containerMain" class="textCenter" style="height: 70vh">
                </div><!-- /.chart__body -->
                <div *ngIf="isUser" id="containerMain" class="textCenter" style="height: 60vh">
                </div><!-- /.chart__body -->
            </div>
        </div>

        <div style="text-align: center; font-size:small" *ngIf="!mobile">Past performance is not an indication of future results.<br/><br/></div>
		<div style="text-align: center; margin-left: 2vw; font-size: small;" *ngIf="mobile">Past performance is not an indication of future results.<br/><br/></div>
    </div><!-- /.shell -->
</section>